export * from './component-origin-promise'
export * from './get-storage-object-from-storage'
export * from './store-component-origin-for-next-page'
